import * as React from "react";
const SvgArrowLeft24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 20,
        fill: "black",
        viewBox: "0 0 12 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m10.293.293 1.414 1.414L3.414 10l8.293 8.293-1.414 1.414L.586 10 10.293.293Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowLeft24Px;
